import { isPast, isFuture } from "../../support/dates";
import { isOpenNow } from "../../domain/hours";
import type { Occurrence } from "../../types";

export function pastEventHours<Type extends Occurrence>(
  occurrences: Array<Type>,
  now: Date
): Array<Type> {
  return occurrences.filter(function (occurrence) {
    return isPast(occurrence.until, now);
  });
}

export function presentEventHours<Type extends Occurrence>(
  occurrences: Array<Type>,
  now: Date
): Array<Type> {
  return occurrences.filter(function (occurrence) {
    return isOpenNow(occurrence, now);
  });
}

export function futureEventHours<Type extends Occurrence>(
  occurrences: Array<Type>,
  now: Date
): Array<Type> {
  return occurrences.filter(function (occurrence) {
    return isFuture(occurrence.from, now);
  });
}
